// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3OR7k","label":"Radio_label__3OTqI","checkMark":"Radio_checkMark__1kFNj","disabled":"Radio_disabled__2D3fu"};